import {get as httpGet} from "../../services/BackendService";
import {LoginUserWithAccount} from "../../services/UsersService";

export const searchLoginUsers = async (email: string): Promise<LoginUserWithAccount[]> => {
  const query = new URLSearchParams({email_search: `%${email}%`});
  return await httpGet<LoginUserWithAccount[]>(`/loginUsers?${query.toString()}`);
};
